import { render, staticRenderFns } from "./PassWord.vue?vue&type=template&id=f67c162a&scoped=true"
import script from "./PassWord.vue?vue&type=script&lang=js"
export * from "./PassWord.vue?vue&type=script&lang=js"
import style0 from "./PassWord.vue?vue&type=style&index=0&id=f67c162a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67c162a",
  null
  
)

export default component.exports